const CheckedGreenOutlineYouGo = ({ color }: { color?: string }) => {
    return (
      <span>
        <svg
          width="12"
          height="9"
          viewBox="0 0 12 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.66674 7.11463L10.7947 0.985962L11.7381 1.92863L4.66674 8.99996L0.424072 4.7573L1.36674 3.81463L4.66674 7.11463Z"
            fill={color ?? '#0D9A62'}
          />
        </svg>
      </span>
    );
  };
  
  export default CheckedGreenOutlineYouGo;